import { TEMPLATE_COMPONENT_TYPE } from "../../constants/template";

export const mapTemplates = (templates) => {
  return templates.map((template) => {
    const components = mapComponents(template.components);

    return {
      id: template.id,
      name: template.name,
      status: template.status,
      type: template.type,
      category: template.category,
      components,
    };
  });
};

const mapComponents = (components) => {
  const baseComponent = components[0];

  const bodyComponent = components.find(
    (component) => component.type === TEMPLATE_COMPONENT_TYPE.BODY,
  );
  const headerComponent = components.find(
    (component) => component.type === TEMPLATE_COMPONENT_TYPE.HEADER,
  );
  const footerComponent = components.find(
    (component) => component.type === TEMPLATE_COMPONENT_TYPE.FOOTER,
  );
  const buttonsComponent = components.find(
    (component) => component.type === TEMPLATE_COMPONENT_TYPE.BUTTONS,
  );

  const body = bodyComponent?.text || baseComponent?.exampleBody?.body_text;
  const headerUrl =
    headerComponent?.exampleHeader?.header_handle[0] ||
    baseComponent?.exampleHeader?.header_handle[0];
  const footer = footerComponent?.text || "";

  const selectButtons = buttonsComponent?.buttons || baseComponent?.buttons;

  const buttons = selectButtons.map((button) => ({
    type: button.type,
    text: button.text,
  }));

  const variables =
    bodyComponent?.exampleBody?.body_text ||
    baseComponent?.exampleBody?.body_text;

  return {
    body,
    headerUrl,
    variables: variables || [],
    footer,
    buttons,
  };
};
